import React from "react";
import { Menu, Dropdown } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import { furnishingUseMutation } from '../hooks';
import FurnishingForms from '../forms';

import Icons from 'components/icons';
import { EntityRemoveButton, ModalStandard, Localize } from 'components/service';


const FurnishingActionField = ({ furnishing, variables }) => {

    const furnishingID = furnishing?.id;

    const {
        _setMutationFurnishingDelete,
        loadingMutationFurnishingDelete,
    } = furnishingUseMutation.delete({ furnishingID });


    let items = [
        {
            key: '1',
            icon:
                <ModalStandard
                    width={ 380 }
                    extraClass={ 'modal-form' }
                    modalButton={
                        <span style={ { display: 'flex', alignItems: 'center', width: '100%' } } ><Icons.Edit /> <Localize>MENUS_DROP.Label_Edit</Localize></span>
                    }>

                    <strong className='modal-title'><Localize>FORMS.Title_EditFurnishing</Localize></strong>
                    <FurnishingForms.Edit furnishing={ furnishing } variables={ variables } />
                </ModalStandard>
        },
        {
            key: '2',
            icon:
                <EntityRemoveButton
                    modalButton={
                        <span style={ { display: 'flex', alignItems: 'center', width: '100%' } } ><Icons.Delete /> <Localize>MENUS_DROP.Label_Delete</Localize></span>
                    }
                    nameEntity={ Localize({ children: "ENTITY.Modal_Title_Furnishing" }).props.children }
                    dataNameEntity={ furnishing?.title }
                    loading={ loadingMutationFurnishingDelete }
                    deleteMutation={ _setMutationFurnishingDelete }
                    variables={ {
                        id: furnishingID,
                    } }
                />,
        },
    ]


    return (
        <Dropdown
            // trigger={['click']}
            placement="bottomRight"
            overlay={ <Menu items={ items } /> }
            overlayClassName="drop-more-menu"
            arrow
        >
            <EllipsisOutlined className="btn-more" />
        </Dropdown>
    )
};

export default FurnishingActionField;